/* eslint-disable react/prop-types */
import React from 'react';
import { SelectDropdown } from '@gsa/afp-component-library';
import './make-model-table.scss';

import MakeModelTypeAheadGroup from '../../../../../components/make-model/make-model-typeahead-group';
import MakeAndModelHeader from './make-and-model-header';
import { useFvsPreBidContext } from '../../../fvs-pre-bid-selection-provider';

const MakeAndModelSearchPanel = ({ hasChassis, handleAddMakeAndModel }) => {
  const state = useFvsPreBidContext();
  const { modelYear, setModelYear } = state;

  const headers = ['Make', 'Model', 'Chassis Make', 'Chassis Model'];
  const tableWidth = hasChassis ? 'chassisWidth' : 'makeAndModelWidth';

  const getModelYearRange = (previousYears, nextYears) => {
    const currentYear = new Date().getFullYear();
    const years = [{ value: '', label: '-Select-' }];
    for (
      let i = currentYear - previousYears;
      i <= currentYear + nextYears;
      i += 1
    ) {
      years.push({ value: i, label: i.toString() });
    }
    return years;
  };

  return (
    <>
      <div className="introWrapper">
        <div>
          <strong>Make and Model</strong>
        </div>
        <div>
          <p>
            <strong>Select existing Make and Models:</strong> To select an
            existing Make and Model, you may begin typing and choose from the
            suggestions available in the dropdown list.
          </p>
          <p>
            <strong>Request new entry:</strong> For entries not found in the
            dropdown list, you may enter your new Make and Model and click
            ‘Add’. New entries will go through a review process and be listed as
            ‘Needs engineering review’ then ‘Engineering approved ’ if approved
            or ‘Engineering rejected’ if declined.
          </p>
          <p>
            <strong>Duplicate entry:</strong> Also, please note that duplicate
            entries are not allowed i.e. if you have already entered a
            particular Make and Model combination then you won`t be able to add
            it again.
          </p>
        </div>
      </div>

      <div className={`headerTitleWrapper ${tableWidth}`}>
        <div
          className="statusWrapper"
          style={{ width: hasChassis ? '218px' : '236px' }}
        >
          <p className="titleHeader">Status</p>
        </div>
        {headers.map((header, index) => {
          if (
            !hasChassis &&
            (header === 'Chassis Make' || header === 'Chassis Model')
          ) {
            return null;
          }
          return (
            <MakeAndModelHeader
              key={header}
              index={index}
              title={header}
              hasChassis={hasChassis}
              headers={header}
            />
          );
        })}
        <MakeAndModelHeader title="Model year" />
        <div className="makeAndModelActions">
          <p className="titleHeader">Actions</p>
        </div>
      </div>
      <div className={`searchInputWrapper ${tableWidth}`}>
        <MakeModelTypeAheadGroup
          state={state}
          showChassis={hasChassis}
          requiresChassis
          disablePaste
          fieldWrapperClassName="typeAheadWrapper"
        />
        <div className="typeAheadWrapper">
          <SelectDropdown
            name="model_year"
            onChange={({ target: { value } }) => setModelYear(value)}
            value={modelYear}
            options={getModelYearRange(1, 3)}
            className=""
          />
        </div>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus */}
        <div
          className="addBtn"
          style={{ cursor: 'pointer' }}
          onClick={handleAddMakeAndModel}
          role="button"
        >
          <p className="btnTxt" data-testid="add_make_model_btn">
            <span className="btnIcon">+</span>
            Add
          </p>
        </div>
      </div>
    </>
  );
};

export default MakeAndModelSearchPanel;
